<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted () {
    // if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    //   // 如果开启系统dark mode, 则设置 <html dark='true'>
    //   document.documentElement.setAttribute('dark', true)
    // }
  }
}
</script>

<style>
html {
  width: 100%;
  height: 100%;
  /*--bg-color: #ffffff;
  --color: #2c3e50;*/
}
/*html[dark] {
  --bg-color: #000000;
  --color: #ffffff;
}*/
body {
  width: 100%;
  height: 100%;
  margin: 0px 0px 0px 0px;
  overflow: hidden;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  width: 100%;
  height: 100%;
}
.el-tabs__content{
  height: calc(100% - 60px);
  padding-top: 15px !important;
}
.el-drawer__body {
  height: 100%;
}
.el-form {
  margin-bottom: 150px;
}
/*@media(prefers-color-scheme: dark) {
  body {
    background: var(--bg-color);
    color: var(--color);
  }
  .splitpanes {
    background: var(--bg-color);
    color: var(--color);
  }
}*/
</style>
